import React, { useMemo, useState, useRef, useEffect, memo } from "react";
import { Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { Spinner } from "reactstrap";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export const ConnectionStatus = memo(({ hubConnection, connected, connecting, start, disconnect }) => {
  const [isConnected, setConnected] = useState(connected);
  const [forceShow, setForceShow] = useState(false);
  const prevIsConnected = usePrevious(isConnected);

  useEffect(() => {
    setConnected(connected);
  }, [connected]);

  const setAlert = () => {
    if (!connected) return <Reconnecting />;
    if (prevIsConnected == false && connected) {
      setForceShow(true);
      setTimeout(() => setForceShow(false), 3000);
      return <Reconnected />;
    }
  };

  const alert = useMemo(() => {
    return setAlert();
  }, [connected]);

  if (!hubConnection) return null;
  const show = !connected || forceShow || (hubConnection.connectionState == 0 && !connecting);

  return (
    <div>
      <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "right" }} open={show} autoHideDuration={6000}>
        {alert}
      </Snackbar>
    </div>
  );
});

const NoConnection = () => {
  return (
    <Alert className="da-alert-snack" severity={"warning"}>
      <SystemLabel name={"NoConnection"} />
    </Alert>
  );
};

const Reconnecting = () => {
  return (
    <Alert className="da-alert-snack" severity={"info"}>
      <SystemLabel name={"Reconnecting"} />
      <Spinner
        style={{
          width: "1rem",
          height: "1rem",
          marginLeft: "10px",
          color: "#2196f375",
        }}
      />
    </Alert>
  );
};

const Reconnected = () => {
  return (
    <Alert className="da-alert-snack" severity={"success"}>
      <SystemLabel name={"Reconnected"} />
    </Alert>
  );
};
